import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import JobForm from '../components/JobForm';
import JobList from '../components/JobList';
import CloseJobModal from '../components/CloseJobModal';

const Jobs = () => {
  const { hasPermission } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingJob, setEditingJob] = useState(null);
  const [closingJob, setClosingJob] = useState(null);
  const [search, setSearch] = useState('');
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchJobs();
  }, [search, page]);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      params.append('page', page);
      params.append('limit', 50);

      const response = await axios.get(`/api/jobs?${params.toString()}`);
      setJobs(response.data.jobs);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingJob(null);
    setShowForm(true);
  };

  const handleEdit = (job) => {
    setEditingJob(job);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this job?')) return;

    try {
      await axios.delete(`/api/jobs/${id}`);
      fetchJobs();
    } catch (error) {
      alert('Error deleting job: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingJob(null);
    fetchJobs();
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <Layout>
      <div className="px-4 py-6 sm:px-0">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Jobs</h1>
          {hasPermission('job', 'create') && (
            <button
              onClick={handleCreate}
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              Add Job
            </button>
          )}
        </div>

        <div className="mb-4">
          <input
            type="text"
            placeholder="Search jobs..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            className="w-full max-w-md px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {showForm && (
          <JobForm
            job={editingJob}
            onClose={handleFormClose}
          />
        )}

        {closingJob && (
          <CloseJobModal
            job={closingJob}
            onClose={() => setClosingJob(null)}
            onSuccess={() => { setClosingJob(null); fetchJobs(); }}
          />
        )}

        <JobList
          jobs={jobs}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onClose={setClosingJob}
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      </div>
    </Layout>
  );
};

export default Jobs;
